
export enum StoreId {
    InTime = 'InTime',
    AppStore = 'AppStore',
    GooglePlay = 'GooglePlay',
}
